// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2mfxe","label":"Radio_label__1imIF","checkMark":"Radio_checkMark__2I4OU","disabled":"Radio_disabled__18fsF"};